module.exports = __webpack_public_path__ + "static/sponsorship_img-05-a-9cc8a96ae0148506943788792ccc80cf.jpg";